import type { Batch, Skipped } from '@/types/api'

const NAMED_REASONS = 3

export type BatchVerb = 'convert' | 'delete' | 'download' | 'render'

export function summarize(verb: BatchVerb, done: number, skipped: Skipped[]): string | null {
  if (!skipped.length) return null

  const named = skipped.slice(0, NAMED_REASONS).map((s) => `${s.filename} — ${s.reason}`)
  const rest = skipped.length - named.length
  const total = done + skipped.length
  const lead = done ? `Queued ${done} of ${total} to ${verb}.` : `Nothing to ${verb}.`

  return [lead, ...named, rest ? `And ${rest} more.` : ''].filter(Boolean).join(' ')
}

export function applyBatch<T>(
  verb: BatchVerb,
  batch: Batch<T>,
  apply: (item: T) => void,
  report: (message: string) => void,
): void {
  for (const item of batch.items) apply(item)

  const summary = summarize(verb, batch.items.length, batch.skipped)
  if (summary) report(summary)
}
